import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../services/ApiService'
import { DATA_ALREADY_EXIST } from '../../utility/ResponseConstant'
import { showAlert } from '../../utility/SweetAlert'
import { useNavigate } from 'react-router-dom'

const InteractorFundXendit = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const addInvoice = useCallback(
    (payload = {}, loadingCallback, transaction_uid = () => {}) => {
      const uid = transaction_uid
      const payloadRequest = {
        ...payload,
      }
      loadingCallback(true)
      ApiService.jsonRequest('/fund-xendit/invoice-create', payloadRequest, (response) => {
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t(`response_message.data_has_been_added`),
            timer: 1500,
          })
          navigate(`/order/view?uid=${uid}`)
        } else {
          if (response.messages === DATA_ALREADY_EXIST) {
            showAlert({
              icon: 'error',
              message: t(`response_message.${response.messages}`),
              timer: 1500,
            })
          } else {
            showAlert({
              icon: 'error',
              message: t(`response_message.internal_server_error`),
              timer: 1500,
            })
          }
        }
        loadingCallback(false)
      })
    },
    [navigate, t],
  )

  return { addInvoice }
}

export default InteractorFundXendit
